import axios from "axios";

export default {
    getFlextimeHistory: async (personId, companyId) => {
        const { data } = await axios.get(`/history`, { params: {
            related_type: ['flextime', 'calendar'],
            person_id: personId,
            company_ids: companyId
        }})

        return data
    },
    saveFlextime: async (flextimeId, status, dateFrom, dateUntil, flextimeType, flextimeWeek, personId, companyId, comment, duration) => {
        if (!flextimeId) {
            flextimeId = 0
        }

        const { data } = await axios.post(`/flextime/${flextimeId}`, {
            status,
            date_from: dateFrom,
            date_until: dateUntil,
            flextime_type: flextimeType,
            flextime_week: flextimeWeek,
            person_id: personId,
            company_id: companyId,
            comment,
            duration
        })

        return data
    },
    saveAccountCredit: async(personId, companyId, flextimeCredit, vacationCredit) => {
        const { data } = await axios.post(`/flextime/credit/${companyId}/${personId}`, {
            flextime_credit: flextimeCredit,
            vacation_credit: vacationCredit
        })

        return data
    },
    deleteFlextime: async (flextimeId) => {
        const { data } = await axios.delete(`/flextime/${flextimeId}`)

        return data
    },
}
